import { useState } from "react";
import { LiveTv } from "@mui/icons-material";
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { currentUser } from "@/App";
import { useNavigate } from "react-router-dom";
import { postBroadcastStart } from "@/services/api";

export default function GoLiveButtonContainer() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleGoLive = async () => {
    setLoading(true);
    const response = await postBroadcastStart();
    navigate(
      `/${currentUser.key}/live?key=${response.key}&uri=${response.uri}`
    );
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      {/* <IconButton
        variant="outlined"
        style={{ border: "1px solid #04FFFF", marginRight: "20px" }}
        onClick={handleGoLive}
      >
        {loading ? <CircularProgress size={24} /> : <LiveTv />}
      </IconButton> */}
      <Button
        variant="outlined"
        onClick={handleGoLive}
        color="secondary"
        endIcon={<LiveTv sx={{ mb: 0.5 }} />}
        loading={loading}
      >
        Start Live streaming
      </Button>
    </Box>
  );
}
